













import { Component, Vue } from "vue-property-decorator";
@Component
export default class CookieNotification extends Vue {
  private snackbar = false;

  private mounted() {
    const cookiesAllowed = this.$cookies.get("CookiesAllowed");
    if (!cookiesAllowed) {
      this.snackbar = true;
    }
  }

  private accept() {
    this.$cookies.set("CookiesAllowed", true, "1y");
    this.snackbar = false;
  }
}
